import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useEffect, useCallback } from 'react';
import { IMAGES } from '../../config/imagesConfig';

const CollisionAnimation = () => {
  const leftCircleControls = useAnimation();
  const rightCircleControls = useAnimation();
  const finalImageControls = useAnimation();

  // Calculamos las posiciones basadas en el ancho del contenedor
  const containerWidth = 600; // ancho del contenedor en desktop
  const circleWidth = 160; // ancho del círculo en desktop (40 * 4)
  const offset = containerWidth / 4; // distancia desde el centro


  // Envolvemos startAnimation en useCallback para evitar recreaciones innecesarias
  const startAnimation = useCallback(async () => {
    // Iniciamos con la imagen final oculta
    await finalImageControls.start({ opacity: 0, scale: 0 });

    const animationSequence = async () => {

      // Fusión suave - las imágenes se desvanecen mientras la final aparece
      await Promise.all([
        finalImageControls.start({
          opacity: 1,
          scale: 1,
          transition: {
            duration: 1.2,
            ease: "easeOut"
          }
        })
      ]);
    };

    animationSequence();
  }, [leftCircleControls, rightCircleControls, finalImageControls, circleWidth]);

  useEffect(() => {
    const timer = setTimeout(() => {
      startAnimation();
    }, 1500);

    return () => clearTimeout(timer);
  }, [startAnimation]);

  return (
    <div className="absolute inset-0 flex items-start justify-center overflow-hidden">
      <div className="pt-20 md:pt-28 relative w-[300px] md:w-[400px]">
        <div className="relative h-40 md:h-60">
          <motion.div
            animate={finalImageControls}
            initial={{ opacity: 0, scale: 0 }}
            className="absolute top-0 w-48 md:w-60 h-48 md:h-60 rounded-full overflow-hidden border-4 shadow-lg"
            style={{ x: '30%' }}
          >
            <video
              autoPlay
              playsInline
              loop
              muted
              className="w-full h-full object-cover"
            >
              <source
                src={IMAGES.COUPLE}
                type="video/mp4"
              />
            </video>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CollisionAnimation; 